<template>
	<vx-card no-shadow>
		<div class="export-table">
			<vs-table :data="routed_visit_points_local" v-model="selectedRowsLocal" search>
				<template slot="header">
					<slot name="header"></slot>
				</template>

				<template slot="thead">
					<vs-th> N</vs-th>
					<vs-th>{{ thead_property_names.type }}</vs-th>
					<vs-th>{{ thead_property_names.identification }}</vs-th>
					<vs-th v-if="typeRouting === 'TOUR_PLANNING'">{{ thead_property_names.territoryId }}</vs-th>
				</template>

				<template slot-scope="{data}">
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							{{
								data[indextr].type === "depot"
									? "🏬"
									: data[indextr].type === "break"
									? "⏳"
									: data[indextr].indexPoint
							}}
						</vs-td>
						<vs-td>{{ getTypeLabel(data[indextr].type) }}</vs-td>
						<vs-td>{{ data[indextr].identification }}</vs-td>
						<vs-td v-if="typeRouting === 'TOUR_PLANNING'">{{ data[indextr].territory_id }}</vs-td>
						<template slot="expand">
							<div class="con-expand-users w-full">
								<div class="flex items-center justify-between">
									<vs-list class="border border-solid d-theme-border-grey-light">
										<vs-list-item
											style="font-size: 12px"
											icon="schedule"
											:title="$t('Routing.Table.EstimatedTimeArrival')"
										>
											{{ data[indextr].estimated_time_arrival }}
										</vs-list-item>
										<vs-list-item
											v-if="data[indextr].type !== 'break'"
											style="font-size: 12px"
											icon="timer_off"
											:title="$t('Routing.Table.WaitingTime')"
										>
											{{ data[indextr].waiting_time }}
										</vs-list-item>
										<vs-list-item
											style="font-size: 12px"
											icon="timer"
											:title="$t('Routing.Table.EstimatedStartTask')"
										>
											{{ data[indextr].estimated_start_task }}
										</vs-list-item>
										<vs-list-item
											style="font-size: 12px"
											icon="departure_board"
											:title="$t('Routing.Table.TimeService')"
											>{{ data[indextr].time_service }}
										</vs-list-item>
										<vs-list-item
											style="font-size: 12px"
											icon="av_timer"
											:title="$t('Routing.Table.EstimatedDepartureTime')"
											>{{ data[indextr].estimated_time_depart }}
										</vs-list-item>
										<vs-list-item
											style="font-size: 12px"
											icon="linear_scale"
											:title="$t('Routing.Table.DistanceFromPrevious')"
											>{{ parseFloat(data[indextr].distance_from_previous).toFixed(2) || 0 }}
										</vs-list-item>
										<vs-list-item
											style="font-size: 12px"
											icon="directions"
											:title="$t('Routing.Table.TotalDistanceTraveled')"
											>{{ parseFloat(data[indextr].total_distance_traveled).toFixed(2) || 0 }}
										</vs-list-item>
									</vs-list>
								</div>
							</div>
						</template>
					</vs-tr>
				</template>
			</vs-table>
		</div>
	</vx-card>
</template>

<script>
import moduleRouting from "@/store/routing/moduleRouting.js";

export default {
	props: {
		routed_visit_points: {
			type: Array,
			default: () => [],
		},
		thead_property_names: {
			type: Object,
			default: {},
		},
		typeRouting: {
			type: String,
			default: "OPENROUTE",
		},
		selectedRows: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectedRowsLocal: this.selectedRows,
		};
	},
	computed: {
		routed_visit_points_local() {
			return this.formarRoutedVP(this.routed_visit_points);
		},
		getTypeLabel() {
			return (type) => {
				switch (type) {
					case "break":
						return this.$t("Routing.Table.Break");
					case "depot":
						return this.$t("Routing.Table.Depot");
					case "pickup":
						return this.$t("Routing.Table.Pickup");
					case "delivery":
						return this.$t("Routing.Table.Delivery");
					default:
						return type;
				}
			};
		},
	},
	methods: {
		/**
		 * @description Funcion para formatear la data de tal modo que agreguemos los index de los elementos
		 * solo de tipo point en una propiedad llamada indexPoint
		 * @param {Array} routedVisitPoints array de puntos de visita ruteados
		 */
		formarRoutedVP(routedVisitPoints = []) {
			let indexPoint = 0;
			return routedVisitPoints.map((rv) => {
				if (rv.type === "point" || rv.type === "pickup" || rv.type === "delivery") {
					indexPoint += 1;
					rv["indexPoint"] = indexPoint;
				}
				return rv;
			});
		},
	},
	watch: {
		selectedRowsLocal(val) {
			this.$emit("handleSelectedEmit", val);
		},
		selectedRows: {
			handler(newVal) {
				this.selectedRowsLocal = newVal;
			},
			immediate: true,
		},
	},
	created() {
		if (!moduleRouting.isRegistered) {
			this.$store.registerModule("moduleRouting", moduleRouting);
			moduleRouting.isRegistered = true;
		}
	},
};
</script>
